export default "__VITE_ASSET__DOneWsdD__"